export interface InvoiceClient {
  id: string;
  userId: string;
  companyName: string;
  firstName: string;
  lastName: string;
  address: string;
}

export type InvoiceType = 'Staff augmentation' | 'Service';
export enum InvoiceTypeEnum {
  StaffAugmentation = 'Staff augmentation',
  Service = 'Service',
}
//get
export interface InvoiceGetDTO {
  id: string;
  client: InvoiceClient;
  startDate: string;
  endDate: string;
  status: string;
  url: string;
  companyName: string;
  clientName: string;
  invoiceType: InvoiceType;
  date: string;
  markAsPaid: boolean;
  paymentDate: string | null;
}

//create
export interface InvoiceCreateDTO {
  clientId: string;
  startDate: string; // formato yyyy-mm-dd
  endDate: string; // formato yyyy-mm-dd
  invoiceType: InvoiceType;
}

//Detail
export interface InvoiceDetailWeek {
  weekStartDate: string;
  weekEndDate: string;
  totalTimeOfTheWeek: number;
}

export interface InvoiceDetailEmployeeRecord {
  invoiceCode: string;
  name: string;
  project: string;
  totalTimeAllWeeks: number;
  weeks: InvoiceDetailWeek[];
  percentage: number;
}

export interface InvoiceDetailEmployee {
  employeeId: string;
  userId: string;
  firstName: string;
  lastName: string;
  employeeRecords: InvoiceDetailEmployeeRecord[];
  totalTimeOfTheEmployee: number;
  worklogGroupStatus: string;
  employeeInvoiceAmount: number;
  rate: number;
}

export interface InvoiceDetailGeneric {
  description: string[];
  qty: string;
  price: string;
  cost: string;
}

export interface InvoiceDetailModel {
  id: string;
  invoiceNumber: string;
  startDate: string;
  endDate: string;
  date: string;
  status: string;
  invoiceType: InvoiceType;
  rejectedStatusComments: string | null;
  url: string;
  client: InvoiceClient;
  invoiceDetails: InvoiceDetailEmployee[] | InvoiceDetailGeneric[];
  totalInvoiceTime: number;
  totalInvoiceAmount: number;
  taxPercentage: number;
  discount: number;
  subtotal: number;
  tax: number;
  markAsPaid: boolean;
  paymentDate: string | null;
}

export interface InvoiceUpdateStatusContractorDTO {
  invoiceId: string;
  employeeId: string;
  status: string;
}

export interface InvoiceServiceTypeUpdateDTO {
  invoiceId: string;
  serviceDetails: {
    description: Array<string>;
    qty: number;
    price: number;
  }[];
  taxPercentage: number;
  discountAmount: number;
}

export interface InvoicePaidDTO {
  id: string;
  paymentDate: string;
  markAsPaid: boolean;
}
